import { backgroundOrange } from '@/theme/colors'
import styled from 'styled-components'

export const PageContainer = styled.div`
	background-color: ${backgroundOrange};
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`

export const CenteredContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	min-height: 100vh;
	padding: 2rem;
	background-color: ${backgroundOrange};

	@media (max-width: 600px) {
		padding: 1.25rem 1rem;
	}
`

export const SpinnerWrapper = styled.div`
	margin-bottom: 1.25rem;
`

export const LoadingText = styled.p`
	font-size: 1rem;
	color: #6c757d;
	margin: 0;
	font-weight: 500;
`

export const ErrorTitle = styled.h2`
	font-size: 1.4rem;
	font-weight: 700;
	color: #212529;
	margin: 1rem 0 0.625rem 0;
	text-align: center;
`

export const ErrorMessage = styled.p`
	font-size: 0.95rem;
	color: #6c757d;
	margin: 0;
	text-align: center;
	max-width: 380px;
	line-height: 1.6;
`
